export const DISCHARGE_CALENDAR_VIEWS = {
  WEEK: 'week',
  MONTH: 'month',
  DAY: 'day',
  LIST: 'list',
} as const;

export const DISCHARGE_CALENDAR_ROUTES = {
  BASE: '/discharge-calendar',
  WEEK: `/discharge-calendar/${DISCHARGE_CALENDAR_VIEWS.WEEK}`,
  MONTH: `/discharge-calendar/${DISCHARGE_CALENDAR_VIEWS.MONTH}`,
  DAY: `/discharge-calendar/${DISCHARGE_CALENDAR_VIEWS.DAY}`,
  LIST: `/discharge-calendar/${DISCHARGE_CALENDAR_VIEWS.LIST}`,
} as const;
